import { IAppState } from '../../common/state';
import { getCurrentRegionId } from '../getCurrentRegionId';

export const getMortgageBannerUrl = (state: IAppState): string => {
  const regionId = getCurrentRegionId(state);

  return `/cat.php/?deal_type=sale&engine_version=2&from_developer=1&offer_type=flat&is_discount_mortgage=1&region=${regionId}`;
};
